import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import { styled } from '@mui/material/styles';
import Layout from '../components/Layout';
import CustomerServiceIcon from '../icons/customer-service.svg';

const PageContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  minHeight: '100vh',
  backgroundColor: '#F7FAFC',
}));

const MainContent = styled(Box)(({ theme }) => ({
  flexGrow: 1,
  padding: theme.spacing(3),
  marginLeft: 80, // Width of sidebar
}));

const PlaceholderContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(8),
  textAlign: 'center',
  height: '100%',
}));

const PlaceholderIcon = styled('img')(({ theme }) => ({
  width: 128,
  height: 128,
  marginBottom: theme.spacing(4),
  opacity: 0.6,
}));

const CustomerSupportPage: React.FC = () => {
  return (
    <PageContainer>
      <Layout>
        <MainContent>
          <PlaceholderContainer>
            <PlaceholderIcon src={CustomerServiceIcon} alt="Customer Support" />
            <Typography variant="h3" sx={{ fontWeight: 600, color: '#1A202C', mb: 2 }}>
              Customer Support
            </Typography>
            <Typography variant="h6" color="text.secondary" sx={{ mb: 4 }}>
              Customer support features coming soon
            </Typography>
            <Paper sx={{ p: 4, maxWidth: 600 }}>
              <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
                We're working on building comprehensive customer support tools including:
              </Typography>
              <Box component="ul" sx={{ textAlign: 'left', pl: 3 }}>
                <Typography component="li" variant="body1" color="text.secondary" sx={{ mb: 1 }}>
                  Ticket management system
                </Typography>
                <Typography component="li" variant="body1" color="text.secondary" sx={{ mb: 1 }}>
                  Live chat support
                </Typography>
                <Typography component="li" variant="body1" color="text.secondary" sx={{ mb: 1 }}>
                  Knowledge base and documentation
                </Typography>
                <Typography component="li" variant="body1" color="text.secondary" sx={{ mb: 1 }}>
                  Customer feedback collection
                </Typography>
              </Box>
            </Paper>
          </PlaceholderContainer>
        </MainContent>
      </Layout>
    </PageContainer>
  );
};

export default CustomerSupportPage; 